import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import spIcon from "../../assets/brand/swlogo.png";
import spWordmark from "../../assets/brand/swletters.png";
import api from "../../api/api";
import { toast } from "react-toastify";

export const Signup = () => {
  const [email, setEmail] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !isChecked) {
      toast.warn("Please fill in all fields and accept the terms");
      return;
    }

    try {
      setSubmitting(true);
      await api.auth.sendOtp(email);
      // If success, go to OTP page with the email
      navigate(`/auth/otp?email=${encodeURIComponent(email)}`);
    } catch (err) {
      console.warn("Send OTP failed:", err?.status, err?.data?.message || err?.message);
      toast.warn(err?.data?.message || "Failed to send OTP. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="w-[412px] px-4 py-6">
        {/* Logo */}
        <div className="w-full flex justify-center mb-3">
          <div className="inline-flex items-center gap-[6px] leading-none">
            <img
              src={spIcon}
              alt="Sweet Plate logo"
              className="shrink-0 object-contain w-[56px] h-[76px]"
            />
            <img
              src={spWordmark}
              alt="Sweet Plate"
              className="shrink-0 object-contain h-[56px] w-auto -ml-[4px]"
            />
          </div>
        </div>

        {/* Title */}
        <h1 className="[font-family:'Nunito',Helvetica] font-bold text-[#5d4037] text-2xl leading-8 text-center">
          Join Sweet Plate Vendor
        </h1>

        {/* Subtitle */}
        <p className="[font-family:'Nunito',Helvetica] font-medium text-[#5d4037] text-sm text-center leading-5 mt-2">
          Create your vendor account, upload your meals,
          and connect with hungry customers.
        </p>

        <form onSubmit={handleSubmit} className="mt-5">
          {/* Email field */}
          <label className="[font-family:'Nunito',Helvetica] font-semibold text-[#5d4037] text-base leading-[22px]">
            Email address
          </label>
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full h-[60px] bg-[#fff8e1] rounded-[18px] border border-[#5d4037] px-[17px] py-[18px] [font-family:'Nunito',Helvetica] text-[#7a6f5c] text-base leading-[22px] outline-none"
          />

          {/* Terms */}
          <div className="mt-9 inline-flex items-start gap-[7px]">
            <input
              id="terms-agreement"
              type="checkbox"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
              className="w-5 h-5 mt-0.5 rounded border border-[#5d4037] accent-[#5d4037]"
            />
            <label
              htmlFor="terms-agreement"
              className="w-[300px] [font-family:'Nunito',Helvetica] text-sm cursor-pointer"
            >
              <span className="text-[#62552c]">
                I certify that I am 18 years of age or older, and I agree to the{" "}
              </span>
              <span className="text-[#663114] underline">User Agreement</span>
              <span className="text-[#62552c]"> and </span>
              <span className="text-[#663114] underline">Privacy Policy</span>
            </label>
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={submitting}
            className={`mt-6 w-full h-[60px] rounded-[50px] [font-family:'Nunito',Helvetica] font-bold text-[#5d4037] text-base leading-[22px] transition-opacity ${
              submitting ? "bg-[#d9c48c] cursor-not-allowed" : "bg-[#f7c945] hover:opacity-90"
            }`}
          >
            {submitting ? "Sending code..." : "Verify Email"}
          </button>

          {/* Login link */}
          <div className="mt-6 text-center [font-family:'Nunito',Helvetica] text-base leading-6">
            <span className="font-medium text-[#a99451]">Do you have an account?</span>
            <span className="font-medium text-[#1f233673]">&nbsp;</span>
            <Link to="/auth/login" className="font-semibold text-[#663114] underline hover:opacity-80">
              Login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};
